function validYear(year) {
    let companyDate = new Date(year +'-01-01');
    let currentYear = new Date().getFullYear();
    let currentDate = new Date(currentYear +'-01-01')

    if (companyDate.getTime() <= currentDate.getTime()) {
        return true
    } else {
        return false
    }
}

const checkCompanyReg = (reg) => {
    const regArray = reg.split('');
    const kregArray = reg.slice(1).split('')
    const regArraySlash = reg.split('/');

    
    if (reg.startsWith('k') || reg.startsWith('K')) {
        for (let index = 0; index < kregArray.length; index++) {
            const element = kregArray[index];
            if (isNaN(element)) {
               return false
            }
        }

        if (reg.split('').length !== 11) {
           return false
        } else if (!validYear(reg.slice(1,5))) {
           return false
        }
        
    }
    else {
        if (typeof(reg) !== "string") {
            return {"valid": false, "issue":"Must be string"}
        } else if (regArray[4] !== '/') {
           return false
        } else if (regArray[11] !== '/') {
           return false
        } else if (!validYear(reg.split('/')[0])) {
           return false
        } else if (reg.split('/')[1].split('').length !== 6) {
           return false
        } else if (reg.split('/')[2].split('').length !== 2) {
           return false
        }

        for (let index = 0; index < regArraySlash.length; index++) {
            const element = regArraySlash[index];
            if (isNaN(element)) {
               return false
            }
        }
    }


    return true
}

export {checkCompanyReg, validYear};